import { render, staticRenderFns } from "./PB.vue?vue&type=template&id=3dad58a0&scoped=true"
import script from "./PB.vue?vue&type=script&lang=js"
export * from "./PB.vue?vue&type=script&lang=js"
import style0 from "./PB.vue?vue&type=style&index=0&id=3dad58a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dad58a0",
  null
  
)

export default component.exports